































import { computed, defineComponent } from '@vue/composition-api';
import isEqual from 'date-fns/isEqual/index';
import setHours from 'date-fns/setHours/index';
import setMilliseconds from 'date-fns/setMilliseconds/index';
import setMinutes from 'date-fns/setMinutes/index';
import setSeconds from 'date-fns/setSeconds/index';

export default defineComponent({
	props: {
		startDate: {
			type: Date,
			required: false,
			default: null,
		},
		endDate: {
			type: Date,
			required: false,
			default: null,
		},
	},
	setup(props) {
		const hasEndDate = computed(() => props.endDate && !isEqual(props.startDate, props.endDate));
		const isSingleDayEvent = computed(() => hasEndDate.value
			&& isEqual(normalizeDateToDay(props.startDate), normalizeDateToDay(props.endDate)));
		return {
			hasEndDate,
			isSingleDayEvent,
		};
	},
});

function normalizeDateToDay(date: Date) {
	return setMilliseconds(setSeconds(setMinutes(setHours(date, 0), 0), 0), 0);
}
